import { trpc } from '@tencent/tpro_rmonitor_manage_server_app_manage';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

type IGetDepartmentsByUserReq = WithTypeCast<trpc.rmonitor.manage_server.IGetDepartmentsByUserReq>;
type IDepartment = WithTypeCast<trpc.rmonitor.manage_server.IDepartment>;
type IGetProductGroupsByUserReq = WithTypeCast<trpc.rmonitor.manage_server.IGetProductGroupsByUserReq>;
type IGetProductGroupsByUserV2Rsp = WithTypeCast<trpc.rmonitor.manage_server.IGetProductGroupsByUserV2Rsp>;
type IGroup = WithTypeCast<trpc.rmonitor.manage_server.IGroup>;
type IProductRegisterReq = WithTypeCast<trpc.rmonitor.manage_server.IProductRegisterReq>;
type IProductRegisterResp = WithTypeCast<trpc.rmonitor.manage_server.IProductRegisterResp>;
export type IGetFormListConfigReq=WithTypeCast<trpc.rmonitor.manage_server.GetFormListConfigReq>;
export type IGetFormListConfigRsp=WithTypeCast<trpc.rmonitor.manage_server.GetFormListConfigRsp>;

export enum MonitorKey {
  AI_MONITOR = 'ai_monitor',
}

export class AppManagerService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.AppManagerService,
    });
  }

  public async getDepartmentsByUser(req: IGetDepartmentsByUserReq): Promise<IDepartment[]> {
    try {
      const res = await this.trpcPost('GetDepartmentsByUser', req);

      return get(res, 'department', []);
    } catch (e) {
      return [];
    }
  }

  public async getProductGroupsByUserV2(req: IGetProductGroupsByUserReq): Promise<IGetProductGroupsByUserV2Rsp> {
    try {
      return  await this.trpcPost('GetProductGroupsByUserV2', req);
    } catch (e) {
      return {
        groups: [],
        products: [],
      };
    }
  }

  public async getDepartments(req: IGetDepartmentsByUserReq): Promise<IDepartment[]> {
    try {
      const res = await this.trpcPost('GetDepartments', req);
      return get(res, 'department', []);
    } catch (e) {
      return [];
    }
  }

  /**
   * 成功返回groupid，失败返回null
   * @param req
   */
  public async projectGroupRegister(req: IGroup): Promise<string> {
    try {
      const res = await this.trpcPost('ProjectGroupRegister', req);
      return get(res, 'groupId', '');
    } catch (e) {
      return '';
    }
  }

  public async productRegister(req: IProductRegisterReq): Promise<IProductRegisterResp> {
    return await this.trpcPost('ProductRegister', req);
  }

  public async getFormListConfig(req: IGetFormListConfigReq): Promise<IGetFormListConfigRsp> {
    return await this.trpcPost('GetFormListConfig', req);
  }
}

export const appManagerService = new AppManagerService();
